export class TimeLineConfiguration {
    rows : Rows[];
    columns : Columns[];
    details : Details[];
    mapping : any[];
}
export class Columns{
    roleCode : string;
    roleId : number;
}
export class Rows{
    status : string;
    requirementtype : string;
}
export class Details{
    id : number;
    roleId : number;
    status : string;
    requirementtype : string;
    startDate : string;
    endDate : string;
    active : number;
}
export class UpdatedTimeline{
    ID : number;
    StartDate : string;
    EndDate : string;
}